import React, { useState, useCallback, useRef, useEffect } from 'react';
import QuizContent from '../shared/QuizContent';
import QuizTitle from '../shared/QuizTitle';
import QuizOptions from '../shared/QuizOptions';
import QuizOption from '../shared/QuizOption';
import LazyImage from '../shared/LazyImage';
import { getQuizOptionsData, QUIZ_OPTIONS_DATA } from '../../constants';
import { loadCharacterAttributes, getAttributeId as getAttrId } from '../../utils/api';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { trackStep4 } from '../../utils/analytics';
import { useDesign } from '../../contexts/DesignContext';
import bgBottomImages from '../../assets/valentinesDay/bgBottomImages.png';
import iconRose from '../../assets/valentinesDay/iconRose.png';
import iconHeart from '../../assets/valentinesDay/iconHeart.png';
import iconHearts from '../../assets/valentinesDay/iconHearts.png';

const Step3 = ({ onAnswer, onPrevious, selections }) => {
  const { isNewDesign } = useDesign();

  const location = useLocation();
  const selectedStyle = location.pathname.includes('/create-ai-hentai')
    ? 'Anime'
    : location.pathname.includes('/create-ai-porn')
    ? 'Realistic'
    : selections?.welcome || 'Realistic';

  const hairColors = getQuizOptionsData('hairColor', selectedStyle);
  const hairStyles = getQuizOptionsData('hairStyle', selectedStyle);
  const eyeColors = getQuizOptionsData('eyeColor', selectedStyle);

  const [selectedHairColor, setSelectedHairColor] = useState(
    hairColors[0]?.value || '',
  );
  const [selectedHairStyle, setSelectedHairStyle] = useState(
    hairStyles[0]?.value || '',
  );
  const [selectedEyeColor, setSelectedEyeColor] = useState(
    eyeColors[0]?.value || '',
  );
  const isHalloween = !!location.pathname.includes('/halloween');

  useEffect(() => {
    loadCharacterAttributes();
  }, []);

  const getAttributeId = (type, label) => getAttrId(type, label, selectedStyle, 'Girls');

  const handleHairColorClick = useCallback(
    (value) => {
      setSelectedHairColor(value);
      const id = getAttributeId('haircolor', value);
      console.log('📝 BodyType answer:', value);
      console.log('🔗 API ID:', id);
    },
    [selectedStyle],
  );

  const handleHairStyleClick = useCallback(
    (value) => {
      setSelectedHairStyle(value);
      const id = getAttributeId('hairstyle', value);
      console.log('📝 BodyType answer:', value);
      console.log('🔗 API ID:', id);
    },
    [selectedStyle],
  );

  const handleEyeColorClick = useCallback(
    (value) => {
      setSelectedEyeColor(value);
      const id = getAttributeId('eyecolor', value);
      console.log('📝 eyecolor answer:', value);
      console.log('🔗 API ID:', id);
    },
    [selectedStyle],
  );

  const handleContinue = useCallback(() => {
    trackStep4(selectedHairStyle, selectedHairColor, selectedEyeColor);

    onAnswer('step3', {
      hairColor: selectedHairColor,
      hairStyle: selectedHairStyle,
      eyeColor: selectedEyeColor,
    });
  }, [selectedHairColor, selectedHairStyle, selectedEyeColor, onAnswer]);

  // Allow continue if all selections are made
  const canContinue =
    selectedHairColor && selectedHairStyle && selectedEyeColor;
  const { t } = useTranslation();
  console.log('hairStyles', hairStyles);
  return (
    <div className="quizContentWrapper">
      <img
        src={bgBottomImages}
        alt=""
        className="step3-center-decoration"
        aria-hidden="true"
      />
      <img
        src={iconRose}
        alt=""
        className="step3-icon-rose"
        aria-hidden="true"
      />
      <img
        src={iconHeart}
        alt=""
        className="step3-icon-heart"
        aria-hidden="true"
      />
      <img
        src={iconHearts}
        alt=""
        className="step3-icon-hearts"
        aria-hidden="true"
      />
      <QuizContent className="step3-design">
        {/* Hair Style Block */}
        <div className="step3-block">
          <QuizTitle>
            {isHalloween || isNewDesign ? (
              <>
                {t('choose')}
                <span className="specialText"> {t('hairS_text')}</span>
              </>
            ) : (
              t('choose_h_style')
            )}
          </QuizTitle>
          <QuizOptions className="hairstyle-options">
            {hairStyles.map((style) => (
              <QuizOption
                key={style.value}
                value={style.value}
                name="hairStyle"
                onClick={handleHairStyleClick}
                className={`hairstyle-option ${
                  selectedHairStyle === style.value
                    ? 'selected'
                    : selectedHairStyle
                    ? 'not-selected'
                    : ''
                } ${hairStyles.length % 2 === 0 ? 'even' : 'odd'}`}
              >
                <div className="hairstyle-image">
                  <LazyImage src={style.image} alt={style.alt} />
                </div>

                <div className="image-title">{t(style.text)}</div>
              </QuizOption>
            ))}
          </QuizOptions>
        </div>

        {/* Hair Color Block */}
        <div className="step3-block">
          <QuizTitle>
            {isHalloween || isNewDesign ? (
              <>
                {t('choose')}
                <span className="specialText"> {t('hairC_text')}</span>
              </>
            ) : (
              t('choose_h_color')
            )}
          </QuizTitle>
          <QuizOptions className="hair-color-options">
            {hairColors.map((color) => (
              <QuizOption
                key={color.value}
                value={color.value}
                name="hairColor"
                onClick={handleHairColorClick}
                className={`hair-color-option ${
                  selectedHairColor === color.value
                    ? 'selected'
                    : selectedHairColor
                    ? 'not-selected'
                    : ''
                } ${hairColors.length % 2 === 0 ? 'even' : 'odd'}`}
              >
                <div className="hair-color-image">
                  <LazyImage src={color.image} alt={color.alt} />
                </div>
                {/* {!isNewDesign && ( */}
                <div className="image-title">{t(color.text)}</div>
                {/* )} */}
                {/* {isNewDesign && (
                  <div className="option-label">{t(color.text)}</div>
                )} */}
              </QuizOption>
            ))}
          </QuizOptions>
        </div>

        {/* Eye Color Block */}
        <div className="step3-block">
          <QuizTitle>
            {isHalloween || isNewDesign ? (
              <>
                {t('choose')}
                <span className="specialText"> {t('eye_text')}</span>
              </>
            ) : (
              t('choose_eye')
            )}
          </QuizTitle>
          <QuizOptions className="eye-color-options">
            {eyeColors.map((color) => (
              <QuizOption
                key={color.value}
                value={color.value}
                name="eyeColor"
                onClick={handleEyeColorClick}
                className={`eye-color-option ${
                  selectedEyeColor === color.value
                    ? 'selected'
                    : selectedEyeColor
                    ? 'not-selected'
                    : ''
                } ${eyeColors.length % 2 === 0 ? 'even' : 'odd'}`}
              >
                <div className="eye-color-image">
                  <LazyImage src={color.image} alt={color.alt} />
                </div>

                <div className="image-title">{t(color.text)}</div>
              </QuizOption>
            ))}
          </QuizOptions>
        </div>

        <div className="navigation-wrapper">
          <button className="previous-button" onClick={onPrevious}>
            {t('previous')}
          </button>
          <button
            className="continue-button"
            onClick={handleContinue}
            disabled={!canContinue}
          >
            {t('next')}
          </button>
        </div>
      </QuizContent>
    </div>
  );
};

export default Step3;
